<script setup lang="ts">
interface Props {
  title?: string
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  class: ''
})
</script>

<template>
  <div :class="['bg-white rounded-lg shadow-md p-6', props.class]">
    <h3 v-if="title" class="text-lg font-semibold text-gray-900 mb-4">
      {{ title }}
    </h3>
    <slot />
  </div>
</template>
